import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { bankBranch, BankBranchManipulationViewModel } from "./bankBranchManipulation-viewModel"

export class BankBranchManipulationView extends View<BankBranchManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-EEA8E1C6-5675-4777-9B97-9E7E075E3A81"
    }
    loadHtml(): string {
        let element = require('./bankBranchManipulation.html').default;
        let style = require('./bankBranchManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set bankBranch(v: ObservableArray<bankBranch>) { this._bankBranch = v; } public get bankBranch(): ObservableArray<bankBranch> { return this._bankBranch;} private _bankBranch: ObservableArray<bankBranch>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestBankBranchCreation(){
        this.dataContext.requestBankBranchCreation();
    }
}
